module.exports = __webpack_public_path__ + "img/form.c18c30c8.svg";